import * as React from 'react';
import IFunding, { TFunding, TFundingData } from './IFunding';
import saveHOC from '../HOC/SaveHOC';
import Industry from '../Industry/Industry';
import Table from '@appComponents/Table/Table';
import Row from './Row';
import Big from 'big.js';
import FundingChart from '../FundingChart/FundingChart';
import { connect } from 'react-redux';
import { animateScrollTo, numberFormatter } from '@features/utils/functions';
import { setFormDirty } from '@company/features/action.company';
import { TReducers } from '@features/reducers';

import * as appStyles from '../../AppStyle.module.scss';
import * as style from './FundingStyle.module.scss'
const isEqual = require('lodash.isequal');
const big = Big();

const tableHeaders = ['Round', 'Date', 'Type', 'Description', 'Share Price', 'Amount'];
const tableHeaderEditMode = ['Round', 'Date', 'Type', 'Description', 'URL to Details',
  'Share Price', 'Amount', ''];

export class Funding extends React.PureComponent<IFunding, TFunding> {
  state = { data: { funding: this.props.funding, fundingToDate: this.props.fundingToDate }, dirtyCall: false };

  componentDidUpdate(prevProps: IFunding, prevState: TFunding) {
    if (!isEqual(prevProps.funding, this.props.funding) ||
      !isEqual(prevProps.fundingToDate, this.props.fundingToDate)) {
      this.setState({
        data: {
          funding: this.props.funding,
          fundingToDate: this.props.fundingToDate,
        },
        dirtyCall: this.props.formDirty,
      });
    }

    if (!isEqual(prevState.data, this.state.data) &&
      this.props.editMode && !this.props.formDirty && this.state.dirtyCall) {
      this.props.dispatch(setFormDirty(true));
    }
  }

  displayHeaders = () => {
    return this.props.editMode ? tableHeaderEditMode : tableHeaders;
  }

  displayRows = () => {
    return this.state.data.funding.map((elem: TFundingData, index: number) => (
      !elem._destroy && (
        <Row
          data={elem}
          round={this.state.data.funding.length - index}
          editMode={this.props.editMode}
          key={elem.id}
          deleteRow={this.deleteRow}
          changeValue={this.updateState}
          dispatch={this.props.dispatch}
        />
      )
    ));
  }

  addRound = () => {
    const id = `NEW${new Date().getTime()}`;
    this.setState({
      data: {
        ...this.state.data,
        funding: [
          ...this.state.data.funding,
          {
            id,
            date: '',
            name: '',
            money_raised: '',
            website: '',
            funding_type: 'other',
            share_price: '',
          },
        ],
      },
    }, () => {
      setTimeout(() => {
        const element = document.getElementById(id);
        if (element) animateScrollTo(null, element);
      }, 0);
    });
  }

  deleteRow = (id: number) => {
    if (confirm('Are you sure?')) {
      if (String(id).substring(0, 3) !== 'NEW') {
        this.setState({
          data: {
            ...this.state.data,
            funding: this.state.data.funding.map((el) => {
              if (el.id === id) return { ...el, _destroy: 1 };

              return el;
            }),
          },
          dirtyCall: true,
        });
      } else {
        this.setState({
          data: {
            ...this.state.data,
            funding: this.state.data.funding.filter(el => el.id !== id),
          },
        });
      }
    }
  }

  updateState = (id: number, e: React.ChangeEvent<HTMLInputElement>) => {
    this.setState({
      data: {
        ...this.state.data,
        funding: this.state.data.funding.map((el: TFundingData) => {
          return el.id === id ? { ...el, [e.target.name]: e.target.value } : el;
        }),
      },
      dirtyCall: true,
    });
  }

  updateStateFromIndustry = (name: string, data: any) => {
    this.setState({
      data: {
        ...this.state.data,
        fundingToDate: data,
      },
      dirtyCall: true,
    });
  }

  displayDisclosedFunding = () => {
    const value = this.props.funding.reduce((prev, curr) => {
      return curr.funding_type !== 'other' ? Number(big(prev).add(curr.money_raised)) : Number(big(prev));
    }, 0);

    return <p className={style.disclosedFunding}>Total disclosed funding: <b>${`${numberFormatter(value, 2)}`}</b></p>;
  }

  render() {
    const fundingForChart = this.state.data.funding.filter((el: TFundingData) => !el._destroy);

    return (
      <section className={[style.funding, 'clear-styles'].join(' ')} id="funding">
        <h2>Valuation events</h2>
        <Industry
          industries={this.state.data.fundingToDate}
          editMode={this.props.editMode}
          updateStateFromChild={this.updateStateFromIndustry}
        />

        {this.props.editMode && <button className={appStyles.addButton} onClick={this.addRound}>Add Round</button>}

        {this.state.data.funding.length > 0 ? (
          <>
            <Table headers={this.displayHeaders()}>
              {this.displayRows()}
            </Table>

            {!this.props.editMode && this.displayDisclosedFunding()}

            {!this.props.editMode && <FundingChart founded={this.props.founded} funding={fundingForChart} />}
          </>
        ) : <div className={style.empty}><p>No funding</p></div>}
      </section>
    );
  }
}

const mapStateToProps = (store: TReducers) => {
  return {
    fundingToDate: store.companyReducer.companyDetails.funding_to_date,
    funding: store.companyReducer.funding,
    formDirty: store.companyReducer.formDirty,
    founded: store.companyReducer.companyDetails.founded,
  };
};

export default connect(mapStateToProps)(saveHOC(Funding, 'funding'));
